import { render, staticRenderFns } from "./ProductServerList.vue?vue&type=template&id=652884d2&scoped=true"
import script from "./ProductServerList.vue?vue&type=script&lang=js"
export * from "./ProductServerList.vue?vue&type=script&lang=js"
import style0 from "./ProductServerList.vue?vue&type=style&index=0&id=652884d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652884d2",
  null
  
)

export default component.exports